import React from "react";
import { Typography, Box } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import dayjs from "dayjs"; // Import Dayjs for validation

export default function AuditCalendar({
  selectedDate,
  onDateChange,
  onAuditCreated,
}) {
  const handleDateChange = (newDate) => {
    if (newDate && dayjs(newDate).isValid()) {
      onDateChange(newDate.toDate()); // Convert to JavaScript Date object and trigger callback
      if (onAuditCreated) onAuditCreated(); // Trigger refresh of the audit list
    } else {
      console.error("Invalid date selected:", newDate);
    }
  };

  return (
    <Box sx={{ maxWidth: "50px", mx: "100px" }}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateCalendar
          value={selectedDate ? dayjs(selectedDate) : null} // Convert selectedDate to Dayjs
          onChange={handleDateChange} // Trigger handleDateChange on date selection
        />
      </LocalizationProvider>
    </Box>
  );
}
